import React from "react";
import { motion } from "framer-motion";
import { Github, ExternalLink } from "lucide-react";

function ProjectCards(props) {
  return (
    <motion.div 
      whileHover={{ y: -10 }}
      className="group relative flex flex-col h-full glass rounded-3xl border-white/5 overflow-hidden transition-all duration-500 hover:border-neon/30 hover:shadow-[0_0_30px_rgba(0,241,254,0.1)]"
    >
      <div className="relative aspect-video overflow-hidden">
        <img 
          src={props.imgPath} 
          alt={props.title} 
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-80 group-hover:opacity-100" 
        />
        <div className="absolute inset-0 bg-gradient-to-t from-dark via-transparent to-transparent opacity-60"></div>
      </div>

      <div className="p-6 flex flex-col flex-grow space-y-4">
        <h3 className="text-2xl font-bold font-manrope text-white group-hover:text-neon transition-colors">
          {props.title}
        </h3>
        
        <p className="text-neutral-400 text-sm leading-relaxed flex-grow">
          {props.description}
        </p>

        <div className="flex items-center gap-4 pt-4">
          <a
            href={props.ghLink}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 px-4 py-2 bg-white/5 border border-white/10 rounded-xl text-white hover:bg-primary hover:border-primary transition-all text-sm font-bold"
          >
            <Github size={18} />
            GitHub
          </a>
          
          {props.demoLink && (
            <a
              href={props.demoLink}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 px-4 py-2 bg-neon/10 border border-neon/20 rounded-xl text-neon hover:bg-neon hover:text-dark transition-all text-sm font-bold"
            >
              <ExternalLink size={18} />
              Demo
            </a>
          )}
        </div>
      </div>
    </motion.div>
  );
}

export default ProjectCards;
